// extracted by mini-css-extract-plugin
module.exports = {"price":"OrderSummary-Price-module--price--3FQ6I","strong":"OrderSummary-Price-module--strong--1h2sL"};